<template>
  <v-container>
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <orders_table
          ref="table"
          @close_form="close_form()"
          @update_data="get_data()"
        ></orders_table>
      </div>
    </div>
  </v-container>
</template>

<script>
import orders_table from "@/components/customers/orders_table";
export default {
  name: "employees_page",
  data() {
    return {
    };
  },
  components: {
    orders_table,
  },

  methods: {
    update_table() {
      this.$refs.table.get_data();

    },
    close_form() {
      if (this.$refs.form) {
        this.$refs.form.close_form();
      }
    },
  },
  mounted() {

  },
};
</script>
